import Messages from './messages'
import Conversations from './conversations'
import { StyleWrapper } from './style'
import { useSelector } from 'react-redux'
import { useLocation } from 'react-router-dom'
const Chat = () => {
  const conversation = useSelector((state: any) => state.conversation)
  const { data: user } = useSelector((state: any) => state.user)
  const { state } = useLocation()
  const messageProps = {
    receiver: !!state?.receiver
      ? state?.receiver
      : conversation?.user1?.id == user?.id
        ? conversation?.user2
        : conversation?.user1,
    sender: {
      id: user?.id,
      name: user?.name,
      avatar: user?.avatar,
    },
  }
  return (
    <StyleWrapper>
      <Conversations {...messageProps} />
      <Messages {...messageProps} />
    </StyleWrapper>
  )
}

export default Chat
